import { render, staticRenderFns } from "./multipleSelect.vue?vue&type=template&id=2d2aaddc&scoped=true&"
import script from "./multipleSelect.vue?vue&type=script&lang=js&"
export * from "./multipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./multipleSelect.vue?vue&type=style&index=0&id=2d2aaddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2aaddc",
  null
  
)

export default component.exports